export function tab() {
    const tabButtons = document.querySelectorAll('.p-top-about__tab-button');
    const contentSections = document.querySelectorAll('.p-top-about__content');

    if (contentSections.length > 0) {
        tabButtons[0].classList.add('current');
        contentSections.forEach((section, index) => {
            section.style.display = index === 0 ? 'block' : 'none';
        });
    }

    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const targetId = button.getAttribute('data-target');
            tabButtons.forEach(btn => btn.classList.remove('current'));
            button.classList.add('current');
            contentSections.forEach(section => section.style.display = 'none');
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                targetSection.style.display = 'block';
            }
        });
    });
}

export function serviceTab() {
  const careerItems = document.querySelectorAll('.p-service-career__item');
  const contentSections = document.querySelectorAll('.p-service-career__inner');

  // Function to get URL parameter
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Get the tab parameter from the URL
  const tabParam = getUrlParameter('tab');

  // If a tab parameter is present, activate the corresponding tab
  if (tabParam) {
    contentSections.forEach(section => section.style.display = 'none'); // ←追加！
  
    careerItems.forEach(item => {
      const targetId = item.getAttribute('data-target');
      if (targetId === tabParam) {
        item.classList.add('current');
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          targetSection.style.display = 'block';
        }
      } else {
        item.classList.remove('current');
      }
    });
  }

  careerItems.forEach(item => {
    item.addEventListener('click', function() {
      const targetId = item.getAttribute('data-target');

      careerItems.forEach(item => item.classList.remove('current'));

      item.classList.add('current');

      contentSections.forEach(section => section.style.display = 'none');

      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        targetSection.style.display = 'block';
      }
    });
  });
}
